import React from 'react';
export interface itrState {
  appStarted: boolean;
  signinClicked: boolean;
}
export interface itrDispatch {
  dispatch: React.Dispatch<itrAction>;
}

export interface itrInitialState {
  appStarted: boolean;
  signinClicked: boolean;
  appMessage: boolean;
  auth: boolean | any;
}
export interface itrAction {
  type: string;
  data?: any;
}

export const initalContext: itrDispatch = {
  dispatch: (arg: any): any => arg,
};

export const initalState: itrInitialState = {
  appStarted: false,
  signinClicked: false,
  appMessage: false,
  auth: false,
};
